function trackBannerClick(banner_name, page_location, banner_location, location) {
  
  //let page_type = '';

  // switch(location) {
  //   case 'index':
  //     page_type = 'Homepage';
  //     break;
  //   case 'product':
  //     page_type = 'Product Page';
  //     break;
  //   case 'collection':
  //     page_type = 'Collection Page';
  //     break;
  //   case 'cart':
  //     page_type = 'Cart Page';
  //     break;
  //   case 'page':
  //     page_type = location.title;
  //     break;
  //   default:
  //     page_type = 'Other: ' + location;
  // }

  // if(page_type == 'Collection Page') {
  //   page_type = page.title;
  // }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'ga4_auto_event',
    'event_name': 'banner',
    'banner_name': banner_name,
    'page_location': page_location,
    'banner_location': banner_location,
    'location': location,
  });
}